module.exports = __webpack_public_path__ + "static/media/hamburger.6451db6b.svg";